export const site = {
  name: "美国禁忌4",
  enName: "AMERICAN TABOO IV",
  tagline: "剧集简介 · 角色档案 · 最新资讯",
  intro:
    "《美国禁忌4》影视专题站，围绕这部悬疑剧的四季主线，系统整理剧集章节、角色档案与最新资讯，帮助剧迷完整梳理剧情脉络与人物关系。",
  footerNote:
    "本站为影视内容资讯与专题展示站点，所有剧情介绍与角色资料均为虚构示例内容，仅供剧迷交流参考，不提供任何播放、下载或在线观看服务。",
  contactEmail: "hello@american-taboo4.example",
};

export const navItems = [
  { key: "home", label: "首页", path: "/", icon: "ri-home-5-line" },
  { key: "episodes", label: "剧集", path: "/episodes", icon: "ri-film-line" },
  { key: "characters", label: "角色", path: "/characters", icon: "ri-user-star-line" },
  { key: "news", label: "资讯", path: "/news", icon: "ri-newspaper-line" },
  { key: "search", label: "搜索", path: "/search", icon: "ri-search-line" },
  { key: "about", label: "关于", path: "/about", icon: "ri-information-line" },
];

export const heroSlides = [
  {
    id: "final-season",
    badge: "最终季",
    title: "最终季 · 最后一封信",
    subtitle: "迟到十年的信，揭开哥哥失踪背后的完整动机。真相的边界，从来比真相本身更难面对。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20small%20town%20skyline%20at%20night%20with%20a%20lone%20figure%20standing%20before%20an%20old%20house%2C%20deep%20blue%20and%20amber%20street%20lights%2C%20moody%20atmospheric%20premium%20drama%20key%20art&width=1600&height=900&seq=hero-final-v1&orientation=landscape",
    to: "/episodes/s4e1",
    cta: "查看剧集详情",
  },
  {
    id: "power-shift",
    badge: "高能连载",
    title: "权力更迭 · 猎人与猎物",
    subtitle: "当旧的秩序被更激进的人取代，小镇一夜之间失去了表面的平静。谁才是真正的猎手？",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20foggy%20forest%20at%20night%20with%20torch%20beams%20cutting%20through%20trees%2C%20deep%20blue%20shadows%20and%20warm%20amber%20glow%2C%20tense%20thriller%20key%20art&width=1600&height=900&seq=hero-power-v1&orientation=landscape",
    to: "/episodes/s4e2",
    cta: "进入本集",
  },
  {
    id: "character-map",
    badge: "专题解读",
    title: "一张图看懂四季人物关系",
    subtitle: "谁在保护谁，谁又在欺骗谁。十位核心角色的关系网络与命运走向，一次梳理清楚。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20board%20covered%20in%20character%20cards%20and%20connected%20red%20strings%2C%20deep%20blue%20lighting%20with%20warm%20amber%20accents%2C%20investigation%20premium%20key%20art&width=1600&height=900&seq=hero-chars-v1&orientation=landscape",
    to: "/characters",
    cta: "浏览角色档案",
  },
];

export const seasonFilters = [
  { value: 0, label: "全部季节" },
  { value: 1, label: "第 1 季" },
  { value: 2, label: "第 2 季" },
  { value: 3, label: "第 3 季" },
  { value: 4, label: "第 4 季" },
];

export const characterTypeFilters = [
  { value: "全部", label: "全部角色" },
  { value: "主角", label: "主角" },
  { value: "配角", label: "配角" },
  { value: "反派", label: "反派" },
];

export const newsCategoryFilters = [
  { value: "全部", label: "全部资讯" },
  { value: "剧集新闻", label: "剧集新闻" },
  { value: "官方动态", label: "官方动态" },
  { value: "深度解析", label: "深度解析" },
  { value: "花絮", label: "花絮幕后" },
  { value: "采访", label: "人物采访" },
];